import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Landing from './Landing';
import LandingV2 from './experimental/LandingV2';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingV2 />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
      </Routes>
    </Router>
  );
}

export default App;
